export default {
  'gifts.router.name': 'Green Gift Booth',
  'gift-distribution-history.router.name': 'Gift Distribution History',
  'gift-distribution-history-info.router.name': 'Gift Distribution History Info',
  'giftDistributionHistory.gift.time': 'Gift Redemption Time',
  'giftDistributionHistory.gift.code': 'Gift Code',
  'giftDistributionHistory.customer.name': 'User Name',
  'giftDistributionHistory.customer.phone': 'Phone Number',
  'giftDistributionHistory.device.code': 'Device Code',
  'giftDistributionHistory.device': 'Device',
  'giftDistributionHistory.device.name': 'Device Name',
  'giftDistributionHistory.gift.quantity': 'Gift Quantity',
  'giftDistributionHistory.gift.status': 'Status',
  'giftDistributionHistory.gift.status.id':
    '{status,select, 1 {Processing} 2 {Failed} 3 {Success} 4 {Cancelled} other {Unknown}}',
  'giftDistributionHistory.gift.refundType': 'Refund Status',
  'giftDistributionHistory.gift.refundType.id':
    '{status,select, 1 {Automatic refund} 2 {Manual refund} other {Unknown}}',
  'giftDistributionHistory.title.history': 'History Information',
  'giftDistributionHistory.title.gifts': 'Gift List',
  'gifts.modalTransaction.title': 'Confirm Transaction Reversal',
  'gifts.modalTransaction.note':
    'Reversing the transaction will return points to the customer and may cause a <span style={{color: #1A1A1A}}><strong>quantity discrepancy</strong></span> between the gifts and the actual items. Are you sure you want to proceed?',
  'gifts.modalTransaction.reason': 'Reason',
  'gifts.modalTransaction.reason.p': 'Enter reason for transaction reversal',
};
